import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import FieldItem from './FieldItem';

interface ProfessionalExperienceSectionProps {
  isEditing: boolean;
  profileData: any;
  onEditField: (field: string) => void;
}

const ProfessionalExperienceSection: React.FC<ProfessionalExperienceSectionProps> = ({
  isEditing,
  profileData,
  onEditField,
}) => {
  return (
    <View style={localStyles.sectionCard}>
      <Text style={localStyles.sectionTitle}>Professional experience</Text>
      <View style={localStyles.infoGrid}>
        <FieldItem
          label="Bio"
          value={profileData.bio}
          iconName="file-document"
          isEditing={isEditing}
          onPress={() => onEditField('bio')}
        />

        <FieldItem
          label="Years of Experience"
          value={String(profileData.yearsOfExperience || '')}
          iconName="trophy"
          isEditing={isEditing}
          onPress={() => onEditField('yearsOfExperience')}
        />

        <FieldItem
          label="Specialties"
          value={Array.isArray(profileData.specialties) ? profileData.specialties.join(', ') : (profileData.specialties || '')}
          iconName="whistle"
          isEditing={isEditing}
          onPress={() => onEditField('specialties')}
        />

        <FieldItem
          label="Languages"
          value={Array.isArray(profileData.languages) ? profileData.languages.join(', ') : (profileData.languages || '')}
          iconName="translate"
          isEditing={isEditing}
          onPress={() => onEditField('languages')}
        />
      </View>
    </View>
  );
};

export default ProfessionalExperienceSection;

const localStyles = StyleSheet.create({
  sectionCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 28,
    padding: 24,
    marginBottom: 24,
    borderWidth: 1,
    borderColor: '#F1F5F9',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.03,
    shadowRadius: 10,
    elevation: 3,
  },
  sectionTitle: {
    fontSize: 20,
    fontWeight: '800',
    color: '#1E293B',
    marginBottom: 20,
    letterSpacing: -0.5,
  },
  infoGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    gap: 12,
  },
});


